export enum IMessageDirection {
  Receiving = "Receiving",
  Sending = "Sending",
}

export interface ISender {
  userId: string;
  name: string;
}

export interface IAttachment {
  url: string;
  type: 'image' | 'video' | 'document';
  name?: string;
  size?: number;
}

export interface IChat {
  createdAt: string;
  direction?: string;
  isSeen: boolean;
  sender?: ISender;
  message: string;
  _id: string;
  status?: string;
  messageId?: string;
  chatId?: string;
 attachments?: string[];}

export interface IWhatsappState {
  agentId?: string[];
  chats: IChat[];
  createdAt?: string;
  receiver: string;
  updatedAt?: string;
  _id: string;
}

export interface IChatListItem {
  unReadMessage: any;
  _id: string;
  receiver: string;
  latestMessage: IChat;
  chatId?: string;
}
